import React from 'react';
import ConsultingArea from '../../components/ConsultingArea/ConsultingArea';

import ContactForm from '../ContactFrom/ContactForm';
import { Link } from 'react-router-dom';

const Contactpage = () => {
	return (
		<section className='relative pt-[120px] pb-0  z-20'>
			<div className='wraper'>
				<div className='grid grid-cols-12'>
					<div className='col-span-1'></div>
					<div className='col-span-10 md:col-span-12'>
						<div className='pb-[100px] sm:pb-[60px]'>
							<div className='grid grid-cols-12 gap-3'>
								<div className='col-span-4 md:col-span-6 sm:col-span-12 md:mb-7'>
									<Link
										to='https://maps.app.goo.gl/gy2jjYfWLLoBVSz19'
										target='_blank'
										rel='noopener noreferrer'
									>
										<div className='text-center p-[40px]  shadow-[0_5px_15px_0_rgba(62,65,159,0.1)]'>
											<div className='w-[85px] h-[85px] bg-[#f5f5f5] leading-[85px] text-center mx-auto rounded-[50%]'>
												<div className='icon'>
													<i
														className='text-[35px] leading-[85px] text-[#282e3f] fa fa-map-marker'
														aria-hidden='true'
													></i>
												</div>
											</div>
											<h2 className='text-[25px] text-[#282e3f] font-medium my-[20px]'>
												Adresse
											</h2>
											<p className='text-[#666] text-[16px] leading-[22px]'>
												Bd Frans Dewandre 6<br />
												6000 Charleroi
											</p>
										</div>
									</Link>
								</div>
								<div className='col-span-4 md:col-span-6 sm:col-span-12 md:mb-7'>
									<div className='text-center p-[40px]  shadow-[0_5px_15px_0_rgba(62,65,159,0.1)]'>
										<div className='w-[85px] h-[85px] bg-[#f5f5f5] leading-[85px] text-center mx-auto rounded-[50%]'>
											<div className='icon'>
												<i
													className='text-[35px] leading-[85px] text-[#282e3f] fa fa-envelope'
													aria-hidden='true'
												></i>
											</div>
										</div>
										<h2 className='text-[25px] text-[#282e3f] font-medium my-[20px]'>E-mail</h2>
										<p className='text-[#666] text-[16px] leading-[22px]'>
											secretariat@gava-lex.be
										</p>
										<p className='text-[#666] text-[16px] leading-[22px]'>&nbsp;</p>
									</div>
								</div>
								<div className='col-span-4 md:col-span-6 sm:col-span-12 md:mb-7'>
									<div className='text-center p-[40px]  shadow-[0_5px_15px_0_rgba(62,65,159,0.1)]'>
										<div className='w-[85px] h-[85px] bg-[#f5f5f5] leading-[85px] text-center mx-auto rounded-[50%]'>
											<div className='icon'>
												<i
													className='text-[35px] leading-[85px] text-[#282e3f] fa fa-phone'
													aria-hidden='true'
												></i>
											</div>
										</div>
										<h2 className='text-[25px] text-[#282e3f] font-medium my-[20px]'>Téléphone</h2>
										<p className='text-[#666] text-[16px] leading-[22px]'>+32 (0) 71.70.02.02</p>
										<p className='text-[#666] text-[16px] leading-[22px]'>&nbsp;</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className='col-span-1'></div>
				</div>
			</div>
		</section>
	);
};

export default Contactpage;
